import React from 'react';
export function ProblemSection() {
  return <section className="section-card" data-id="element-126">
      <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-127">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-128">
          El Problema Real Que Nadie Habla
        </h2>

        <div className="space-y-4 text-lg text-blue-100 leading-relaxed" data-id="element-129">
          <p data-id="element-130">
            Te levantas cada día con buenas intenciones. Quieres orar, leer,
            conectar con Dios… pero el ruido del mundo te consume. Las redes
            sociales, las noticias, las preocupaciones, el trabajo.
          </p>

          <p data-id="element-131">
            Y al final del día, te das cuenta:{' '}
            <span className="text-yellow-300 font-semibold" data-id="element-132">
              otra vez no sentiste nada
            </span>
            . Tu fe se siente distante, mecánica, vacía.
          </p>

          <p className="text-xl font-semibold text-white pt-4" data-id="element-133">
            Pero la verdad es esta:
          </p>

          <p className="text-2xl font-bold text-yellow-300 italic" data-id="element-134">
            "Dios nunca se fue. Yo dejé de escucharlo entre tanto ruido."
          </p>
        </div>
      </div>
    </section>;
}